import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { formatDateTimezon } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import TaskApprovalForm from "./TaskApprovalForm";
import ReactImageGallery from "../../components-react/gallery/ReactImageGallery";
import MergedTasks from "../merged-tasks/MergedTasks";
import DetailListings from "./details/DetailListings";
import { EyeIcon } from "../../../images/icons/icons";

const TaskApprovalListings = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
}) => {
  const {
    hygineTaskApprovalLoading,
    hygineTaskApprovalError,
    hygineTaskApproval,
  } = useSelector((state) => state.hygiene);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  useEffect(() => {
    if (
      !hygineTaskApprovalLoading &&
      !hygineTaskApprovalError &&
      hygineTaskApproval?.status &&
      hygineTaskApproval?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: hygineTaskApproval.data,
        pagination:
          hygineTaskApproval?.pagination?.length > 0
            ? hygineTaskApproval.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [hygineTaskApprovalLoading, hygineTaskApprovalError, hygineTaskApproval]);

  const tbColumns = [
    {
      dataField: "status",
      text: "click to change",
      formatter: (_, row) => {
        const isCompleted = row?.status === "completed";

        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8"
            style={{
              background: isCompleted
                ? "#379C00"
                : row?.status === "in_progress"
                ? "#ffc107"
                : "#C80000",
              color: "#fff",
              cursor: !isCompleted ? "pointer" : "not-allowed",
              opacity: !isCompleted ? 1 : 0.5,
            }}
            onClick={() =>
              !isCompleted &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "task_status",
                rowData: row,
              }))
            }
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "task add date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "task_id",
      text: "task name",
      formatter: (_, row) => {
        const taskPriroty = row?.priority || "";
        const priorityColor =
          taskPriroty === "critical"
            ? "#dc3545"
            : taskPriroty === "high"
            ? "#ffc107"
            : taskPriroty === "medium"
            ? "#0d6efd"
            : "#198754";
        const priorityTag =
          taskPriroty === "critical"
            ? "P1"
            : taskPriroty === "high"
            ? "P2"
            : taskPriroty === "medium"
            ? "P3"
            : "P4";

        return (
          <span className="tb-data minWidth150">
            <small className="gray underline">
              {row?.category_name || "-"}
            </small>
            <br />
            <b
              className="link"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "addon",
                  rowData: row,
                }))
              }
            >
              {row?.task_name || "NA"}
            </b>
            <br />
            {row?.priority ? (
              <div
                className="badge"
                style={{
                  borderRadius: "10px",
                  backgroundColor: priorityColor,
                  color: "#fff",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  letterSpacing: "1px",
                  fontWeight: "500",
                  padding: "5px",
                  marginTop: "5px",
                }}
              >
                ({priorityTag}) {row?.priority || "-"}
              </div>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "requested_by",
      text: "requested by",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            <small className="gray">
              {row?.requested_account_type?.replace(/_/g, " ") || ""}
            </small>
            <br />
            {row?.requested_by_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.requested_by_mobile || ""}
              <br />
              {row?.requested_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "details",
      text: "view details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <EyeIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail  Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "addon" ? "" : "mod-width-50p"
          }`}
        >
          {modValues.cardName !== "task_status" && (
            <ModalHeadAndClose
              title={`${
                modValues.cardName === "view_details"
                  ? modValues.rowData?.task_name
                  : modValues.cardName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />
          )}

          {modValues.cardName === "description" ||
          modValues.cardName === "processed_description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.remarks || "No Content Available"}
              </p>
            </div>
          ) : modValues.cardName === "task_status" ? (
            <TaskApprovalForm
              userInfoData={userInfoData}
              cardName={modValues.cardName}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : modValues.cardName === "images" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.images_arr?.length > 0
                    ? modValues.rowData.images_arr
                    : []
                }
              />
            </div>
          ) : modValues.cardName === "videos" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.video_arr?.length > 0
                    ? modValues.rowData.video_arr
                    : []
                }
              />
            </div>
          ) : modValues.cardName === "addon" ? (
            <MergedTasks
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.cardName === "view_details" ? (
            <DetailListings row={modValues.rowData} />
          ) : null}
        </div>
      </Modal>

      {hygineTaskApprovalLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        </div>
      )}
    </>
  );
};

export default TaskApprovalListings;
